/* InLei® — Einwilligung (Cookie-Banner) ohne Fremd-App.

   Ersetzt das Autoblocking der Complianz/iubenda-App, das auf dem Handy
   rund 1,3 s Rechenzeit gekostet hat, und das alte
   inlei-ratingbadge-defer.js. Die Einwilligung selbst speichert Shopify
   (Customer Privacy API); dieses Skript erledigt dreierlei:

   1. Google Consent Mode v2: Grundstellung "abgelehnt", bevor irgendein
      Google-Tag laedt, und Aktualisierung nach der Wahl.
   2. Rueckhalten der Dienste, die sich nicht selbst an Shopifys Einwilligung
      halten (gemessen 2026-10-05 ohne iubenda): Microsoft Clarity zeichnete
      sofort auf, und das Widget der Google-Bewertungs-App setzte das Cookie
      NID und lud Google Fonts. Beide warten jetzt auf ihre Kategorie.
   3. Banner und Einstellungsdialog (Markup: snippets/inlei-einwilligung.liquid).

   Muss synchron im <head> VOR content_for_header stehen, damit die
   Grundstellung vor dem ersten Google-Tag gilt und die DOM-Methoden
   ersetzt sind, bevor Apps ihre Skripte einhaengen. */
(() => {
  if (window.Shopify?.designMode) return;

  /* ---------- 1. Google Consent Mode: Grundstellung ---------- */
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500,
  });
  gtag('set', 'ads_data_redaction', true);

  /* ---------- 2. Skripte bis zur Einwilligung zurueckhalten ---------- */
  /* nachAktion: Das Bewertungssiegel kostet rund 0,4 s Rechenzeit und ist
     fuer den ersten Eindruck unwichtig — es laedt erst nach der ersten
     Nutzeraktion (Scrollen, Tippen, Taste), nicht schon beim Seitenaufbau. */
  const REGELN = [
    { muster: /\/\/[^/]*clarity\.ms\//, kategorie: 'analytics' },
    { muster: /meggnotec\.ams3\.digitaloceanspaces\.com\/sfy\//, kategorie: 'marketing', nachAktion: true },
    { muster: /apis\.google\.com\/js\/platform\.js|\/shopping\/merchantverse/, kategorie: 'marketing', nachAktion: true },
  ];

  const erlaubt = { analytics: false, marketing: false };
  const warteschlange = [];
  let aktionErfolgt = false;
  let siegelWirdEingeblendet = false;

  const origAppend = Element.prototype.appendChild;
  const origInsert = Element.prototype.insertBefore;

  const regelFuer = (knoten) => {
    if (knoten?.tagName !== 'SCRIPT') return null;
    const src = knoten.src || knoten.getAttribute('src') || '';
    return src ? REGELN.find((regel) => regel.muster.test(src)) || null : null;
  };

  const darfLaden = (regel) => erlaubt[regel.kategorie] && (!regel.nachAktion || aktionErfolgt);

  /* Kopie statt Original einhaengen: ein bereits einmal eingefuegtes, aber
     abgefangenes Skript-Element fuehrt der Browser nicht mehr aus. */
  const laden = ({ knoten, eltern, regel }) => {
    const skript = document.createElement('script');
    Array.from(knoten.attributes).forEach((attr) => skript.setAttribute(attr.name, attr.value));
    skript.async = true;
    if (knoten.onload) skript.onload = knoten.onload;
    origAppend.call(eltern?.isConnected ? eltern : document.head, skript);
    if (regel.nachAktion) siegelRuhigEinblenden();
  };

  const freigeben = () => {
    for (let i = warteschlange.length - 1; i >= 0; i -= 1) {
      if (darfLaden(warteschlange[i].regel)) laden(warteschlange.splice(i, 1)[0]);
    }
  };

  const einhaengen = (methode, eltern, knoten, kind) => {
    const regel = regelFuer(knoten);
    if (regel && !darfLaden(regel)) {
      warteschlange.push({ knoten, eltern, regel });
      return knoten;
    }
    return methode.call(eltern, knoten, kind);
  };

  Element.prototype.appendChild = function (knoten) {
    return einhaengen(origAppend, this, knoten);
  };
  Element.prototype.insertBefore = function (knoten, kind) {
    return einhaengen(origInsert, this, knoten, kind);
  };

  /* Nicht abzufangen ist der Konfigurationsabruf www.clarity.ms/tag/shopify/…:
     er kommt aus Shopifys abgeschottetem App-Pixel, nicht aus der Seite
     (setzt keine Cookies, zeichnet nichts auf; mit iubenda ebenso). */

  const aktion = () => {
    if (aktionErfolgt) return;
    aktionErfolgt = true;
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach((typ) => removeEventListener(typ, aktion));
    freigeben();
  };
  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach((typ) =>
    addEventListener(typ, aktion, { passive: true })
  );

  /* Google baut das Siegel sichtbar auf: erst rund 150px hoch, Sekunden
     spaeter auf die endgueltigen 64px geschrumpft. Diese Groessenaenderung
     zaehlte als Layout-Verschiebung (0,067 CLS, gemessen 2026-09-26). Deshalb
     bleibt das Siegel unsichtbar, bis Google sein iframe eingesetzt hat, die
     kompakte Endgroesse (30-100px hoch) erreicht ist und sie RUHE_MS lang
     stillsteht; spaetestens nach HOECHSTENS_MS wird es gezeigt.

     Versteckt wird per Stylesheet-Regel, nicht per Inline-Stil: Google
     schreibt das style-Attribut des Siegels mehrfach komplett neu. */
  const SIEGEL = '#___ratingbadge_0';
  const RUHE_MS = 1500;
  const HOECHSTENS_MS = 20000;
  const SICHTBAR = 'inlei-ratingbadge-sichtbar';

  function siegelRuhigEinblenden() {
    if (siegelWirdEingeblendet) return;
    siegelWirdEingeblendet = true;

    const regel = document.createElement('style');
    regel.textContent = `html:not(.${SICHTBAR}) ${SIEGEL}{visibility:hidden!important}`;
    origAppend.call(document.head, regel);

    let knoten = null;
    let timer = 0;
    let groesse = '';

    const zeigen = () => {
      clearTimeout(timer);
      clearTimeout(notbremse);
      baumBeobachter.disconnect();
      groessenBeobachter.disconnect();
      document.documentElement.classList.add(SICHTBAR);
    };

    const pruefen = () => {
      const aktuell = document.querySelector(SIEGEL);
      if (aktuell !== knoten) {
        if (knoten) groessenBeobachter.unobserve(knoten);
        knoten = aktuell;
        if (knoten) groessenBeobachter.observe(knoten);
      }
      if (!knoten) return;
      const { width, height } = knoten.getBoundingClientRect();
      const jetzt = `${Math.round(width)}x${Math.round(height)}`;
      if (jetzt === groesse) return;
      groesse = jetzt;
      clearTimeout(timer);
      if (knoten.querySelector('iframe') && height >= 30 && height <= 100) timer = setTimeout(zeigen, RUHE_MS);
    };

    /* Den ganzen Teilbaum beobachten: Google legt das Siegel nach dem Laden
       neu an, nicht als direktes Kind von <body> — nur auf <body> zu lauschen
       liess es dauerhaft unsichtbar (live bemerkt 2026-10-05). Teuer ist das
       nicht mehr, weil es erst nach der ersten Nutzeraktion startet und sich
       mit dem Einblenden abschaltet. */
    const groessenBeobachter = new ResizeObserver(pruefen);
    const baumBeobachter = new MutationObserver(pruefen);
    baumBeobachter.observe(document.documentElement, { childList: true, subtree: true });
    const notbremse = setTimeout(zeigen, HOECHSTENS_MS);
    pruefen();
  }

  /* ---------- Einwilligung anwenden ---------- */
  const COOKIES_STATISTIK = /^(_ga|_ga_.*|_gid|_clck|_clsk|CLID|MUID)$/;
  const COOKIES_MARKETING = /^(_gcl_.*|_fbp|_uetsid|_uetvid|_ttp|_tt_enable_cookie)$/;

  const cookiesLoeschen = (muster) => {
    const domain = location.hostname.replace(/^www\./, '');
    document.cookie.split(';').forEach((eintrag) => {
      const name = eintrag.split('=')[0].trim();
      if (!muster.test(name)) return;
      [location.hostname, `.${domain}`, ''].forEach((d) => {
        document.cookie = `${name}=; Max-Age=0; path=/${d ? `; domain=${d}` : ''}`;
      });
    });
  };

  let ersteAnwendung = true;

  const anwenden = (analytics, marketing) => {
    const zurueckgezogen = (erlaubt.analytics && !analytics) || (erlaubt.marketing && !marketing);
    erlaubt.analytics = analytics;
    erlaubt.marketing = marketing;

    gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
    });

    if (!analytics) cookiesLoeschen(COOKIES_STATISTIK);
    if (!marketing) cookiesLoeschen(COOKIES_MARKETING);

    /* Bereits laufende Dienste lassen sich nicht anhalten — nach einem
       Widerruf laedt die Seite neu, dann bleiben sie draussen. */
    if (zurueckgezogen && !ersteAnwendung) {
      location.reload();
      return;
    }
    ersteAnwendung = false;
    freigeben();
  };

  /* ---------- 3. Banner ---------- */
  const WURZEL = document.documentElement;
  const OFFEN = 'inlei-cookie-offen';
  let api = null;
  let banner = null;
  let zuletztFokussiert = null;

  const zeigeStufe = (stufe) => {
    banner.querySelectorAll('[data-stufe]').forEach((teil) => {
      teil.hidden = teil.dataset.stufe !== stufe;
    });
  };

  /* Beim ersten Erscheinen bleibt der Fokus, wo er ist — der Banner steht
     ohnehin als Erstes in der Tab-Reihenfolge. Nur wer ihn selbst oeffnet
     (Fusszeile), landet direkt darin. */
  const bannerOeffnen = (stufe = 'start', fokussieren = false) => {
    if (!banner) return;
    zuletztFokussiert = document.activeElement;
    banner.querySelector('[data-auswahl="analytics"]').checked = erlaubt.analytics;
    banner.querySelector('[data-auswahl="marketing"]').checked = erlaubt.marketing;
    zeigeStufe(stufe);
    banner.hidden = false;
    WURZEL.classList.add(OFFEN);
    if (fokussieren) banner.querySelector(`[data-stufe="${stufe}"] [data-fokus]`)?.focus({ preventScroll: true });
  };

  const bannerSchliessen = () => {
    banner.hidden = true;
    WURZEL.classList.remove(OFFEN);
    if (zuletztFokussiert && zuletztFokussiert !== document.body && zuletztFokussiert.isConnected) {
      zuletztFokussiert.focus({ preventScroll: true });
    }
  };

  const speichern = (analytics, marketing, preferences) => {
    bannerSchliessen();
    const fertig = () => anwenden(analytics, marketing);
    if (!api) return fertig();
    api.setTrackingConsent({ analytics, marketing, preferences }, fertig);
  };

  const unentschieden = () => {
    if (typeof api.currentVisitorConsent === 'function') {
      const wahl = api.currentVisitorConsent() || {};
      return wahl.analytics === '' || wahl.marketing === '';
    }
    return api.getTrackingConsent?.() === 'no_interaction';
  };

  const bannerVerdrahten = () => {
    banner = document.querySelector('[data-inlei-einwilligung]');
    if (!banner) return;

    banner.addEventListener('click', (ereignis) => {
      const knopf = ereignis.target.closest('[data-aktion]');
      if (!knopf) return;
      switch (knopf.dataset.aktion) {
        case 'alle':
          speichern(true, true, true);
          break;
        case 'notwendig':
          speichern(false, false, false);
          break;
        case 'auswahl': {
          const analytics = banner.querySelector('[data-auswahl="analytics"]').checked;
          const marketing = banner.querySelector('[data-auswahl="marketing"]').checked;
          speichern(analytics, marketing, analytics || marketing);
          break;
        }
        case 'einstellungen':
          zeigeStufe('einstellungen');
          banner.querySelector('[data-stufe="einstellungen"] [data-fokus]')?.focus();
          break;
        case 'zurueck':
          zeigeStufe('start');
          banner.querySelector('[data-stufe="start"] [data-fokus]')?.focus();
          break;
        default:
      }
    });

    banner.addEventListener('keydown', (ereignis) => {
      if (ereignis.key !== 'Escape') return;
      if (!banner.querySelector('[data-stufe="einstellungen"]').hidden) {
        zeigeStufe('start');
        banner.querySelector('[data-stufe="start"] [data-fokus]')?.focus();
      }
    });

    /* "Cookie-Einstellungen" in der Fusszeile (und jeder andere Ausloeser) */
    document.addEventListener('click', (ereignis) => {
      const ausloeser = ereignis.target.closest('[data-inlei-einwilligung-oeffnen], a[href="#cookie-einstellungen"]');
      if (!ausloeser) return;
      ereignis.preventDefault();
      bannerOeffnen('einstellungen', true);
    });
  };

  const start = () => {
    bannerVerdrahten();

    const mitApi = () => {
      api = window.Shopify?.customerPrivacy;
      if (!api) return;
      anwenden(api.analyticsProcessingAllowed(), api.marketingAllowed());
      if (api.shouldShowBanner?.() !== false && unentschieden()) bannerOeffnen('start');
    };

    if (window.Shopify?.customerPrivacy) {
      mitApi();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => {
        if (!fehler) mitApi();
      });
    }

    /* Wahl aus einem anderen Tab oder ueber Shopify-eigene Wege (Kasse) */
    document.addEventListener('visitorConsentCollected', (ereignis) => {
      const wahl = ereignis.detail || {};
      anwenden(Boolean(wahl.analyticsAllowed), Boolean(wahl.marketingAllowed));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
